export const locales = ['fr', 'en'] as const

export type LocalesCode = (typeof locales)[number]

export const isSupportedLocale = (locale: string): locale is LocalesCode => {
  return (locales as readonly string[]).includes(locale)
}

// Quasar locales files names:
// https://github.com/quasarframework/quasar/tree/dev/ui/lang
export const quasarLocales = {
  en: 'en-US',
  fr: 'fr',
}
